import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import AuthFooter from '../components/shared/AuthFooter/AuthFooter'
import CreateWallet from '../components/CreateWallet/CreateWallet'
import { WALLET_CREATE_ACTIONS } from '../store/actions/wallet'
import { containsNoErrors } from '../util/helpers'
import WebLoading  from '../components/shared/WebLoading/WebLoading'
import { RECEIVE_WALLET_NAV } from '../constants/navigation'
import requireWallet from '../hoc/requireWallet'
import { getPasswordErrors } from '../util/errors'

const PASSWORD_ERRORS = {
  password: '',
  repeatPassword: ''
}

class CreateWalletContainer extends Component {

  state = {
    errorMessages: PASSWORD_ERRORS,
    checkboxError: false,
    checkboxSelected: false
  }

  componentDidMount() {
    const { wallet, history } = this.props
    if (wallet.address) {
      history.push(RECEIVE_WALLET_NAV)
    }
  }

  componentWillUnmount() {
    this.props.resetCreateWalletState()
  }

  onCreateWalletClick = () => {
    const { checkboxSelected } = this.state
    const { createProfile } = this.props
    this.setState({
      errorMessages: getPasswordErrors(createProfile)
    }, () => {
      if (!checkboxSelected) {
        return this.setState({
          checkboxError: true
        })
      }
      if (containsNoErrors(this.state.errorMessages)) {
        this.props.onCreateWallet(createProfile.password)
      }
    })
  }

  onCheckboxClick = () => {
    this.setState({
      checkboxSelected: !this.state.checkboxSelected,
      checkboxError: false
    })
  }

  render() {
    const { loading, t } = this.props
    return (      
      loading ? <WebLoading text={t(loading)} /> :
        <div className="main-container main-container--flex-column">
        <CreateWallet
          {...this.props}
          {...this.state}
          onCreateWalletClick={this.onCreateWalletClick}
          onCheckboxClick={this.onCheckboxClick}
        />
        <AuthFooter />
      </div>
    )
  }
}

const mapStateToProps = ({ walletReducer, authReducer }) => {  
  const { createProfile } = walletReducer
  return {        
    createProfile: createProfile,
  }
}

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    ...WALLET_CREATE_ACTIONS
  }, dispatch)

export default requireWallet(connect(mapStateToProps, mapDispatchToProps)(CreateWalletContainer))




// WEBPACK FOOTER //
// ./src/containers/CreateWalletContainer.js